// extracted by mini-css-extract-plugin
export default {"cnt":"clients_cnt__dFNzf","titlewhy":"clients_titlewhy__usxhN","whysubtitle":"clients_whysubtitle__9ZwHt","textContainer":"clients_textContainer__jj6Dl"};